import { render, staticRenderFns } from "./StatusUpdates.vue?vue&type=template&id=284c10a2&"
import script from "./StatusUpdates.vue?vue&type=script&lang=js&"
export * from "./StatusUpdates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/StatusUpdates.vue
// module id = null
// module chunks = 